/**
 * Generic modal
 * @method setAlertModal
 */
export function ModalController() {
    //generic
    this.alertModal = null;
    this.alertDescription = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.successModal = null;
    this.alertTranfersPointModal = null;
    //authen
    this.otpModal = null;
    this.pdpaModal = null;
    this.pdpaRegisterModal = null;
    this.alertPointModal = null;
    //redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.drawDeliveryModal = null;
    this.shippingAddressModal = null;
    //address
    this.addAddressModal = null;
    this.editAddressModal = null;
    this.listAddressModal = null;
    this.addTaxAddressModal = null;
    this.editTaxAddressModal = null;
    this.listTaxAddressModal = null;
    //tipcoin
    this.loginModal = null;
    this.passwordModal = null;
    this.confirmTransferMAAIModal = null;
    this.transferFailModal = null;
    this.contractCallCenterModal = null;

    //#region generic
    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setAlertDescription = function(alertDescriptionController) {
        this.alertDescription = alertDescriptionController;
    };
    this.setAlertTranfersPointModal = function(alertTranfersPointModal) {
        this.alertTranfersPointModal = alertTranfersPointModal;
    };
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    this.setSuccessModal = function (successModalController) {
        this.successModal = successModalController;
    };
    //#endregion generic

    //#region authen
    this.setOtpModal = function (otpModalController) {
        this.otpModal = otpModalController;
    };
    this.setPdpaModal = function (pdpaModalController) {
        this.pdpaModal = pdpaModalController;
    };
    this.setPdpaRegisterModal = function (pdpaRegisterModalController) {
        this.pdpaRegisterModal = pdpaRegisterModalController;
    };
    this.setAlertPointModal = function(alertPointModalController) {
        this.alertPointModal = alertPointModalController;
    };
    //#endregion authen

    //#region redeem
    this.setConfirmRedeemModal = function (confirmRedeemModalController) {
        this.confirmRedeemModal = confirmRedeemModalController;
    };
    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
    };
    this.setDrawDeliveryModal = function (drawDeliveryModalController) {
        this.drawDeliveryModal = drawDeliveryModalController;
    };
    this.setShippingAddressModal = function (shippingAddressModalController) {
        this.shippingAddressModal = shippingAddressModalController;
    };
    //#endregion redeem

    //#region address
    this.setAddAddressModal = function (addAddressModalController) {
        this.addAddressModal = addAddressModalController;
    };
    this.setEditAddressModal = function (editAddressModalController) {
        this.editAddressModal = editAddressModalController;
    };
    this.setListAddressModal = function (listAddressModalController) {
        this.listAddressModal = listAddressModalController;
    };
    this.setAddTaxAddressModal = function (addTaxAddressModalController) {
        this.addTaxAddressModal = addTaxAddressModalController;
    };
    this.setEditTaxAddressModal = function (editTaxAddressModalController) {
        this.editTaxAddressModal = editTaxAddressModalController;
    };
    this.setListTaxAddressModal = function (listTaxAddressModalController) {
        this.listTaxAddressModal = listTaxAddressModalController;
    };
    //#endregion address

    this.setLoginModal = function (loginModalController) {
        this.loginModal = loginModalController;
    };
    this.setPasswordModal = function (passwordModalController) {
        this.passwordModal = passwordModalController;
    };
    this.setConfirmTransferMAAIModal = function (confirmTransferMAAIModalController) {
        this.confirmTransferMAAIModal = confirmTransferMAAIModalController;
    };
    this.setTransferFailModal = function (transferFailModalController) {
        this.transferFailModal = transferFailModalController;
    };
    this.setContractCallCenterModal = function (contractCallCenterModalController) {
        this.contractCallCenterModal = contractCallCenterModalController;
    };
}
